import { injectable } from 'inversify';
import { Offset } from '../../interfaces/Offset';
import { ResultEntry } from '../../interfaces/search/ResultEntry';

@injectable()
export class DetailsStorage {
  public entry!: ResultEntry | null;
  public offset!: Offset;

  constructor() {
    this.offset = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }
}
